import { AppSettings } from '@src/core/AppSettings';
import { Injectable } from '@angular/core';

@Injectable()
export class OrisAppSettings extends AppSettings {
    constructor() {
        super();
        // Overwrite default settings specific for Oris. Example below:
        this.MaximumDaysAllowedForWarrantyReturn = 90;
        this.MaximumDaysAllowedForWarrantyReturnExtended = 20000;
        this.PrePairedWarrantyCards = false;
        this.MaximumDaysForPastActivationDate = 365;
    }
}
